import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  constructor(private http: HttpClient) {}

  private handleHttpError(error: HttpErrorResponse) {
    return {
      status: error.status,
      ...(typeof error.error === 'string'
        ? { message: error.error }
        : error.error || {}),
    };
  }

  createMember(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${SETTINGS.BASE_API}/member/create`, payload).subscribe({
        next: (response: any) => resolve(response),
        error: (err: HttpErrorResponse) => reject(this.handleHttpError(err)),
      });
    });
  }

  getPagedMembers(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/member/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getPaidMembers(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/member/get-all`, {}).subscribe({
        next: (response: any) => {
          const paidMembers = (response || []).filter(
            (member: any) =>
              member.paymentStatus && member.paymentStatus.type === 'Paid'
          );
          resolve(paidMembers);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  getAllMembers(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/member/get-all`, {}).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  updateMember(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${SETTINGS.BASE_API}/member/update`, payload).subscribe({
        next: (response: any) => resolve(response),
        error: (err: HttpErrorResponse) => reject(this.handleHttpError(err)),
      });
    });
  }

  softDeleteMember(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/member/soft-delete/${id}`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getOneMemberById(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/member/member/${id}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error.message);
        },
      });
    });
  }

  //Member login side request
  getOneMemberByMemberLogged(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/member/logged-member/profile`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }
  updateMemberByLoggedMember(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/member/logged-member/update`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error);
          },
        });
    });
  }
  changePasswordMemberByLoggedMember(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${SETTINGS.BASE_API}/member/logged-member/change-password`,
          payload
        )
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error);
          },
        });
    });
  }
}
